import React from "react";
import { IConnectTargetType, IGroup, IGroupVisibility } from "~/types/types";
import { useSelfie } from "~/components/auth/Auth";
import Feed from "~/components/feed/Feed";
import WriteContentBox from "~/components/feed/WriteContentBox";

export default function Posts({
  group,
  feedLimit,
}: {
  group: Pick<IGroup, "_id" | "name" | "visibility" | "viewerIsMember">;
  feedLimit?: number;
}) {
  const user = useSelfie();

  if (!user) {
    return null;
  }

  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 24,
      }}
    >
      {group.visibility === IGroupVisibility.Private && (
        <WriteContentBox group={group} user={user} dataIntercomTarget="Group Write Content Box" />
      )}

      <Feed
        targetId={group._id}
        targetType={IConnectTargetType.Group}
        context="group"
        feedLimit={feedLimit}
        showNoPosts={group.viewerIsMember}
      />
    </div>
  );
}
